import { Loader2, Film } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { Reveal } from "@/components/shared/Reveal";
import { VideoCard } from "@/components/video/VideoCard";
import { useData } from "@/context/DataContext";

const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/i5hw6p7x_Novemberka%CC%8Asan%202025-17.webp";

export default function Videor() {
  const { data, loading } = useData();
  const videos = data.videos || [];

  return (
    <>
      <PageHeader kicker="Från arkivet" title="Video" subtitle="Klipp från tidigare Novemberkåsor – känn stämningen, leran och legenderna." image={IMG} />
      <section className="py-16">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          {loading && <div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-amber-500" /></div>}
          {!loading && videos.length === 0 && (
            <div className="grid place-items-center py-20 text-center" data-testid="videos-empty">
              <Film className="h-10 w-10 text-white/20" />
              <p className="mt-4 font-mono text-sm uppercase tracking-widest text-white/40">Videor publiceras snart</p>
            </div>
          )}
          {videos.length > 0 && (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="videos-grid">
              {videos.map((v, i) => (
                <Reveal key={v.id} delay={i * 0.06}><VideoCard video={v} /></Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
